import { AutoComplete } from '@openx/components-core/lib/AutoComplete/AutoComplete';
import type { GeoLocationTypes } from '@openx/types/geoLocation';
import { useTranslation } from 'react-i18next';

import { useTargetingOptionDisabledState } from '../../../utils/hooks/useTargetingOptionDisabledState';
import { geographicLabels } from '../constants';

type GeographicTypeProps = {
  onChange: (type: GeoLocationTypes) => void;
  value: GeoLocationTypes;
};

export const GeographicType = ({ onChange, value }: GeographicTypeProps) => {
  const { t } = useTranslation();
  const { isOptionDisabled } = useTargetingOptionDisabledState();

  return (
    <AutoComplete
      textFieldProps={{ label: t('Type') }}
      options={Object.keys(geographicLabels)}
      renderOptions={{
        dataTest: 'geographic-type-option',
      }}
      getOptionLabel={option => t(geographicLabels[option])}
      getOptionDisabled={option => isOptionDisabled(option)}
      textFieldReadOnly
      disableClearable
      filterOptions={option => option}
      onChange={(_, value) => onChange(value as GeoLocationTypes)}
      value={value}
      data-test="geographic-type"
    />
  );
};
